'use strict';

exports.__esModule = true;
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
exports.default = function (props) {
  return _react2.default.createElement('div', {
    style: style
  }, _react2.default.createElement(_google_map_markers2.default, _extends({}, props, {
    prerender: true
  })));
};
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _google_map_markers = require('./google_map_markers');
var _google_map_markers2 = _interopRequireDefault(_google_map_markers);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var style = {
  width: '50%',
  height: '50%',
  left: '50%',
  top: '50%',
  // backgroundColor: 'red',
  margin: 0,
  padding: 0,
  position: 'absolute'
  // opacity: 0.3
};